import { render, staticRenderFns } from "./mail-reply-qa-content.vue?vue&type=template&id=5c390f09&scoped=true&"
import script from "./mail-reply-qa-content.vue?vue&type=script&lang=js&"
export * from "./mail-reply-qa-content.vue?vue&type=script&lang=js&"
import style0 from "./mail-reply-qa-content.vue?vue&type=style&index=0&id=5c390f09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c390f09",
  null
  
)

export default component.exports